import * as React from 'react';

// #region Component Props

interface IProps {
    text            : string;
    onClick         : any;
    hasMoreResults  : boolean;
}

// #endregion

export const MoreResults = (props: IProps) => (
    <button className="btn-icon action float-right" disabled={ props.hasMoreResults === false} onClick={ props.onClick }>
        <i className="la la-ellipsis-h" />
        { props.text }
    </button>
)